import { WholesaleCatalogType } from '@cbgms/api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@carsys/form'
import { IFormValues } from './types'
import { useFormikContext } from 'formik'

export const hasEMDMFields = (selectedCatalogType: WholesaleCatalogType) => Boolean(selectedCatalogType === WholesaleCatalogType.EMDM)

export const CatalogFieldsEMDM = () => {
  const { t } = useTranslation()
  const {
    values: { wholesaleCatalogType }
  } = useFormikContext<IFormValues>()

  const renderEMDMFields = useMemo(() => hasEMDMFields(wholesaleCatalogType), [wholesaleCatalogType])

  if (!renderEMDMFields) return null
  return (
    <>
      <TextField name='MDMOverrideApplicationID' label={t('wholesaler-catalog.MDMOverrideApplicationID')} />
      <TextField name='MDMOverrideUsername' label={t('wholesaler-catalog.MDMOverrideUsername')} />
      <TextField name='MDMOverridePassword' label={t('wholesaler-catalog.MDMOverridePassword')} />
    </>
  )
}
